import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  PLATFORM_ID,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ASSETS_API_URL } from '@app/app.constants';
import { environment } from 'src/environments/environment';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-cards-home',
  templateUrl: './cards-home.component.html',
  styleUrls: ['./cards-home.component.scss'],
})
export class CardsHomeComponent implements OnInit {
  public picturesServer = ASSETS_API_URL;
  public baseUrl = environment.serverFrontUrl;
  @Input() cardData: any;
  @Input() showElements: boolean;
  @Input() index: any;
  @Output() onNavigationOverview = new EventEmitter<any>();

  isBrowser: boolean;
  images: any[] = [];
  estado: any;

  vista: string;
  arrowhide: boolean = false;
  language = '';
  private changeLangSubscription: Subscription;
  showError = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: number,
    private readonly translateService: TranslateService
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit(): void {
    this.estado =
      this.cardData.propertyHistories[0]?.propertyState?.description;
    if (this.cardData.publicationSummary.main_image.includes('null'))
      this.loadImages();
    else this.images = [this.cardData.publicationSummary.main_image];
    this.language = this.translateService.currentLang;
    this.changeLangSubscription = this.translateService.onLangChange.subscribe(
      (event: LangChangeEvent) => {
        this.language = event.lang;
      }
    );
  }

  loadImages() {
    this.images = this.cardData.propertyHistories[0].property.documents.map(
      (document: any) => document.thumbs_url
    );
    this.images.unshift(this.cardData.publicationSummary.main_image);
    if (this.images.length === 0) {
      this.images = [
        `${this.picturesServer}img/isologo-inviertis-white.png`,
        'https://d1w3nj0fsqjjqy.cloudfront.net/assets/img/isologo-inviertis-white.png',
      ];
    }
  }

  onImageLoadError(evt: any) {
    this.showError = true;
  }

  onImageLoad(evt: any) {
    if (evt && evt.target) {
      const width = evt.target.naturalWidth;
      const height = evt.target.naturalHeight;
      const portrait = height > width ? true : false;
    }
  }

  mouseEnter() {
    this.arrowhide = true;
  }

  mouseLeave() {
    this.arrowhide = false;
  }
  removeOldSearch() {
    sessionStorage.removeItem('search');
  }
}
